import { userSchemas } from "../resources/userSchemas/index";

export default (userData, formType) => {
  return new Promise((resolve, reject) => {
    const errors = [];
    const schema = userSchemas[formType];
    // First, validate all the fields present in the user data (if field should be validated))
    Object.keys(userData).forEach((field) => {
      if (schema.hasOwnProperty(field)) {
        // If validation function provided, use it, otherwise field is ignored
        if (schema[field].hasOwnProperty("validate") === true) {
          const validationResult = schema[field].validate(field, userData);
          if (validationResult !== true) {
            errors.push({
              field: field,
              error: `${schema[field].errorMessagePrefix} ${validationResult}`,
            });
          }
        }
      }
    });

    // Next, ensure all required fields in the schema are present in the data
    Object.keys(schema).forEach((schemaEntry) => {
      if (schema[schemaEntry].required === true) {
        if (
          userData.hasOwnProperty(schemaEntry) !== true ||
          userData[schemaEntry] === null
        ) {
          errors.push({
            field: schemaEntry,
            error: `${schema[schemaEntry].errorMessagePrefix} is required`,
          });
        }
      } else if (schema[schemaEntry].hasOwnProperty("requireIf")) {
        if (schema[schemaEntry].requireIf(userData)) {
          if (
            userData.hasOwnProperty(schemaEntry) !== true ||
            userData[schemaEntry] === null
          ) {
            errors.push({
              field: schemaEntry,
              error: `${schema[schemaEntry].errorMessagePrefix} is required`,
            });
          }
        }
      }
    });

    const results = {
      passedValidation: errors.length === 0,
      errors,
    };
    resolve(results);
  });
};
